export type LimitSelectOption = {
  label: string;
  value: string | number | boolean;
};

export type DataLevelOptions = {
  label: string;
  currencyTypes: LimitSelectOption[];
  filters: Array<{
    key: string;
    label: string;
    options: LimitSelectOption[];
  }>;
};

export function toSelectOptions(options: LimitSelectOption[] = []) {
  return options.map((option) => ({
    label: option.label,
    value: String(option.value),
  }));
}

export function previewSelection(source: {
  currencyType?: string | null;
  currencyTypeKey?: string | null;
  enabledFilterKeys: string[];
  filterValues: Record<string, string[]>;
}) {
  const selection = Object.fromEntries(
    source.enabledFilterKeys.flatMap((key) => {
      const values = source.filterValues[key] ?? [];
      return values.length === 0 ? [] : [[key, values]];
    })
  );

  if (
    source.currencyTypeKey != null &&
    source.currencyTypeKey !== '' &&
    source.currencyType != null &&
    source.currencyType !== ''
  ) {
    selection[source.currencyTypeKey] = [source.currencyType];
  }

  return selection;
}
